import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import Button from '@/components/Button'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import Container from '@/components/Container'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import React from 'react'
import style from './styles/champ.module.scss'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import { IChampionship } from '@/interfaces/Championship'
import { api } from '@/api'
import Filters from './components/Filters'
import ChampionshipCatalogCard from '@/components/Cards/ChampionshipCatalogCard'
import Section from '@/components/Section'
import NoSearchResults from '@/components/NoSearchResults'
import HtmlContent from '@/components/HtmlContent'

const Championships = (): React.ReactElement => {
  const page = usePage()
  const { object } = page?.init_state
  const { config } = page?.init_state?.global

  return (
    <Container>
      <div className={style.champ__titlewrap}>
        <Title type='h1'>{object.title}</Title>
        <Button
          highlight
          href={config.championship_application}
          size='large'
          className={style.champ__button}
        >
          Создать чемпионат
        </Button>
      </div>
      {object !== null ? <HtmlContent className={style.desc} content={object.detail} /> : null}
      <Section>
        <FetcherList
          initFilter={{ page_size: 10, status: 'open' }}
          isScrollTop={false}
          isHistoryPush={false}
          api={api.getChampionships}
        >
          {({
            results,
            status,
            showMore,
            loadData,
            filterParams,
            isNext
          }: IFetcherListResults<IChampionship[]>) => {
            return (
              <>
                <Filters handleFilter={loadData} initFilters={filterParams} />
                {status === dataStates.loaded && results.length === 0
                  ? (
                    <NoSearchResults />
                    )
                  : null}
                {results.length > 0
                  ? (
                    <div className={style.champ_grid}>
                      {results.map((el) => {
                        return (
                          <ChampionshipCatalogCard
                            key={el.id}
                            championship={el}
                          />
                        )
                      })}
                    </div>
                    )
                  : null}
                {status === dataStates.loading ? <BlockSpinner /> : null}
                {isNext
                  ? (
                    <Button disabled={status === dataStates.loading} onClick={showMore} size='large' wide outline>
                      Показать еще
                    </Button>
                    )
                  : undefined}
              </>
            )
          }}
        </FetcherList>
      </Section>
    </Container>
  )
}

export default Championships
